
import {getToken, getUserSettings} from '../storage'
import axios from 'axios'
import {API_BASE_URL} from '../constants'



export function GET(url) {

  return axios({
    url: url,
    baseURL: API_BASE_URL,
    headers: {
      common: {
        'Authorization': 'Token ' + getToken()
      }
    }
  })

}

export function POST(url, data) {

  return axios({
    url: url,
    baseURL: API_BASE_URL,
    method: 'POST',
    data: data,
    headers: {
      common: {
        'Authorization': 'Token ' + getToken()
      }
    },
    post: {
      'Content-Type': 'multipart/form-data;'
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/ajax.js